/**
 * Stats API Service
 *
 * Statistiken zur User-Library
 *
 * Endpoints:
 * GET /stats/overview - Übersicht (manga_count, band_count, etc.)
 * GET /stats/facts    - Automatisch generierte Fun-Facts über die eigene Sammlung
 * GET /stats/{user_id} - Statistik-Übersicht eines anderen Users (privacy-aware)
 */

import { get } from '../client';

/**
 * Stats-Übersicht laden
 * @returns {Promise<{success: boolean, data?: StatsOverview, error?: object}>}
 * 
 * Response Data:
 * {
 *   manga_count: number,
 *   band_count: number,
 *   completed_manga_count: number,
 *   reading_now_count: number
 * }
 */
export const getOverview = async () => {
  return get('/stats/overview');
};

/**
 * Fortschritt für einen einzelnen Manga laden
 * @param {number} mangaId - Manga ID
 * @returns {Promise<{success: boolean, data?: MangaProgress, error?: object}>}
 *
 * Response Data:
 * {
 *   owned_bands: number,
 *   total_bands: number,
 *   percent: number
 * }
 */
export const getMangaProgress = async (mangaId) => {
  return get(`/library/mangas/${mangaId}/progress`);
};

/**
 * Automatisch generierte Fun-Facts über die eigene Sammlung laden (§16)
 * @returns {Promise<{success: boolean, data?: {facts: string[]}, error?: object}>}
 */
export const getFacts = async () => {
  return get('/stats/facts');
};

/**
 * Stats-Übersicht eines anderen Users laden (privacy-aware, §15/§16)
 * @param {number} userId - User ID
 * @returns {Promise<{success: boolean, data?: StatsOverview, error?: object}>}
 *
 * Errors: 403 PRIVATE_RESOURCE
 */
export const getUserOverview = async (userId) => {
  return get(`/stats/${userId}`);
};

// ============================================================================
// TYPES (JSDoc)
// ============================================================================

/**
 * @typedef {object} StatsOverview
 * @property {number} manga_count - Anzahl Mangas in der Library
 * @property {number} band_count - Anzahl Bände in der Library
 * @property {number} completed_manga_count - Vollständig gesammelte Mangas
 * @property {number} reading_now_count - Aktuell am Lesen
 */
